import request from '@/utils/request'

// 開獎號碼 api

export const getHistoryData = function(cpCode, query) {
  return request({
    url: `/v1/cp168/apis/ruleDetails/${cpCode}`,
    method: 'get',
    params: query
  })
}

// 雙面統計
export const getShuangMianData = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/todayDxdsStatistics`,
    method: 'get',
    params: query
  })
}

// 長龍統計
export const getChangLongData = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/nowDragon`,
    method: 'get',
    params: query
  })
}

// 正/特碼熱門統計

export const getHmHot = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/hmHot`,
    method: 'get',
    params: query
  })
}

// 正/特碼遺漏統計

export const getHmLost = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/hmLost`,
    method: 'get',
    params: query
  })
}

// 正/特碼生肖熱門統計

export const getHmShengXiaoHot = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/hmShengXiaoHot`,
    method: 'get',
    params: query
  })
}

// 正/特碼生肖遺漏統計

export const getHmShengXiaoLost = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/hmShengXiaoLost`,
    method: 'get',
    params: query
  })
}
